import React from 'react';
import { Pager, PageChangeEvent } from '@progress/kendo-react-data-tools';
import { isMobile } from 'react-device-detect';

export type PagerProps = {
    skip: number;
    take: number;
    total: number;
    onChange: (e: PageChangeEvent) => void;
}

const ActionPager: React.FC<PagerProps> = (props) => {
    //Page size is and System setting
    //const { data: hostConfig } = useGetHostConfigQuery(userProfile?.Tenant_Uid, { skip: !userProfile?.Tenant_Uid });

    //If the skip is greater than the total, reset the skip
    if (props.skip > props.total) {
        props.onChange({ skip: 0, take: props.take } as PageChangeEvent);
    }

    if (props.total <= props.take) return null;

    if (!props.take) return null;


    let pageSizes = [10, 20, 50, 100];
    //Add the page size to the pager if its not in the list of page sizes
    if (props.take && !pageSizes.includes(props.take)) {
        pageSizes.push(props.take)
        pageSizes = pageSizes.sort((a, b) => a - b);
    }

    return (
        <>
            <Pager
                responsive={true}
                skip={props.skip}
                take={props.take}
                total={props.total}
                onPageChange={props.onChange}
                buttonCount={isMobile ? 5 : 10}
                info={true}
                previousNext={true}
                type="numeric"
                pageSizeValue={props.take}
                pageSizes={pageSizes}
            />
        </>
    )
};

export default ActionPager;